import axios from '@/service/request';

// 个人资料
export const info = params => axios.get('/member/info', { params: { ...params } });

// 作品
export const getShortVideos = params => axios.get('/member/getShort', { params: { ...params } });

// 私密
export const getPrivateVideos = params => axios.get('/member/getPrivate', { params: { ...params } });

// 收藏电影
export const getVideoCollect = params => axios.get('/member/getVideoCollect', { params: { ...params } });

//  收藏短视频
export const getShortCollect = params => axios.get('/member/getCollect', { params: { ...params } });
// 喜欢
export const getLikeVideos = params => axios.get('/member/getlike', { params: { ...params } });

//  专属短视频
export const getFanShort = params => axios.get('/member/getExclusive', { params: { ...params } });

// 取消关注
export const unFollow = params => axios.post('/member/addUnsubscribe', params);

// 修改头像
export const addAvatar = params => axios.post('/member/addAvatar', params);

// 修改背景
export const addBackground = params => axios.post('/member/addBackground', params);

//  社区帖子-我的发布
export const getMyposts = params => axios.get('/posts/getMyposts', { params: { ...params } });

//  我的评论
export const getMyMessage = params => axios.get('/posts/getMyMessage', { params: { ...params } });

//  我的收藏
export const getMyCollect = params => axios.get('/posts/getMyCollect', { params: { ...params } });
